import React from 'react'
import './workflow-template-modal.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { getRequestHeaders } from '../../api'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../adminTaskUtils'
import Subtask2023 from '../../TaskCardModal2023/Subtask2023/Subtask2023'

const WorkflowTemplateModal = ({
    workflowTemplateModal2023,
    setWorkflowTemplateModal2023,
    editWorkflow,
    setEditWorkflow,
    templateResource = 'templates',
}) => {
    const [saving, setSaving] = React.useState(false)
    const [saveError, setSaveError] = React.useState('')
    React.useEffect(() => taskCardAnimateIn('workflow-template-modal-2023__wrapper', 'workflow-template-modal-2023'), [])

    const resourcePath = templateResource === 'studentworkflowtemplates'
        ? 'studentworkflowtemplates'
        : 'templates'

    const checkForAutoClear = (val) => {
        val === "Customize Workflow" && setWorkflowTemplateModal2023({...workflowTemplateModal2023, todoName: ''})
    }

    const saveAndCloseWorkflowTemplate = async () => {
        if (saving) return
        setSaving(true)
        setSaveError('')

        try {
            if (editWorkflow) {
                await axios.put(
                    `${baseUrl}/${resourcePath}/${workflowTemplateModal2023.todoId}`,
                    workflowTemplateModal2023,
                    getRequestHeaders()
                )
            } else {
                await axios.post(
                    `${baseUrl}/${resourcePath}`,
                    workflowTemplateModal2023,
                    getRequestHeaders()
                )
            }

            taskCardAnimateOut('workflow-template-modal-2023__wrapper', 'workflow-template-modal-2023')
            setEditWorkflow(false)
            setWorkflowTemplateModal2023(false)
        } catch (error) {
            console.error('Unable to save workflow template:', error)
            setSaveError(
                error?.response?.data?.message ||
                error?.response?.data ||
                'Unable to save this template. Please try again.'
            )
        } finally {
            setSaving(false)
        }
    }

    const todoSubtasks = Array.isArray(workflowTemplateModal2023?.todoSubtasks)
        ? workflowTemplateModal2023.todoSubtasks
        : []

    return (
        <div className='workflow-template-modal-2023__wrapper' id='workflow-template-modal-2023__wrapper'>
            <div className='workflow-template-modal-2023' id='workflow-template-modal-2023'>
                <input className='workflow-template-modal-2023__task-name' value={workflowTemplateModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setWorkflowTemplateModal2023({...workflowTemplateModal2023, todoName: e.target.value})} />
                {todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setWorkflowTemplateModal2023} imEditingATemplate={true} />)}
                <div className='workflow-template-modal-2023__add-subtask' onClick={() => setWorkflowTemplateModal2023({...workflowTemplateModal2023, todoSubtasks: [...todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                {saveError && <div className='workflow-template-modal-2023__save-error' role='alert'>{String(saveError)}</div>}
                <div className='workflow-template-modal-2023__btn-wrapper'>
                    <div className='workflow-template-modal-2023__btn__no' onClick={() => setWorkflowTemplateModal2023(false)}>Cancel</div>
                    <div
                        className={`workflow-template-modal-2023__btn__yes ${saving ? 'is-saving' : ''}`}
                        onClick={() => saveAndCloseWorkflowTemplate()}
                        aria-disabled={saving}
                    >
                        {saving ? 'Saving…' : 'Save Changes'}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default WorkflowTemplateModal
